import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './ProductPhotoCarousel.module.css';

export interface ProductPhotoCarouselProps {
	images: string[];
	current?: number;
	onCurrentChange?: (index: number) => void;
	className?: string;
}

export const ProductPhotoCarousel = ({ images, current: controlledCurrent, onCurrentChange, className }: ProductPhotoCarouselProps) => {
	const [internalCurrent, setInternalCurrent] = useState(0);

	const current = controlledCurrent ?? internalCurrent;
	const setCurrent = (i: number) => {
		setInternalCurrent(i);
		onCurrentChange?.(i);
	};

	if (!images.length) return null;

	const prev = () => setCurrent((current - 1 + images.length) % images.length);
	const next = () => setCurrent((current + 1) % images.length);

	return (
		<div className={`${styles.wrapper} ${className ?? ''}`}>
			<div className={styles.imageContainer}>
				<img
					src={images[current]}
					alt={`Foto do produto ${current + 1}`}
					className={styles.image}
				/>
				{images.length > 1 && (
					<>
						<button type="button" className={`${styles.arrow} ${styles.arrowLeft}`} onClick={prev} aria-label="Foto anterior">
							<ChevronLeft className={styles.arrowIcon} />
						</button>
						<button type="button" className={`${styles.arrow} ${styles.arrowRight}`} onClick={next} aria-label="Próxima foto">
							<ChevronRight className={styles.arrowIcon} />
						</button>
					</>
				)}
			</div>

			{images.length > 1 && (
				<div className={styles.dots}>
					{images.map((src, i) => (
						<button
							key={src}
							type="button"
							className={`${styles.dot} ${i === current ? styles.dotActive : ''}`}
							onClick={() => setCurrent(i)}
							aria-label={`Ir para foto ${i + 1}`}
						/>
					))}
				</div>
			)}
		</div>
	);
};
